import React from 'react';

/**
 * Editorial hero block: small uppercase eyebrow, large headline, optional lede,
 * optional footnote. Headline, lede, and footnote may be JSX so callers can
 * pass colored or weighted spans.
 *
 * `horizonLabel`, when set, is appended to the eyebrow in indigo so the
 * forecast horizon scope (Intraday, D+1, …) is visible alongside the period
 * without the reader having to scan the filter bar.
 *
 * `footnote` renders below the lede in smaller, muted text — for at-a-glance
 * caveats (e.g. missed-day penalty fill) that should sit close to the headline
 * without competing with it.
 */
export default function AnalyticsHero({
  eyebrow,
  headline,
  lede,
  footnote,
  horizonLabel,
  className = '',
}) {
  const showEyebrow = eyebrow || horizonLabel;
  return (
    <header className={`mb-6 ${className}`}>
      {showEyebrow ? (
        <div className="text-xs uppercase tracking-[0.14em] font-medium text-gray-500 dark:text-gray-400 mb-2">
          {eyebrow}
          {eyebrow && horizonLabel ? (
            <span className="mx-2">·</span>
          ) : null}
          {horizonLabel ? (
            <span className="font-medium text-brand-600 dark:text-brand-400">
              {horizonLabel}
            </span>
          ) : null}
        </div>
      ) : null}
      <h2 className="text-2xl sm:text-3xl font-medium tracking-tight leading-tight text-gray-900 dark:text-gray-100">
        {headline}
      </h2>
      {lede ? (
        <p className="mt-3 text-sm sm:text-base text-gray-600 dark:text-gray-300 leading-relaxed">
          {lede}
        </p>
      ) : null}
      {footnote ? (
        <p className="mt-1.5 text-xs text-gray-500 dark:text-gray-400 leading-relaxed">
          {footnote}
        </p>
      ) : null}
    </header>
  );
}
